import { Routes } from '@angular/router';
import {
  canActivateAuthGuard,
  OktaCallbackComponent,
} from '@okta/okta-angular';

export const routes: Routes = [
  { path: '', redirectTo: '/main', pathMatch: 'full' },
  { path: 'authorization-code/callback', component: OktaCallbackComponent },
  {
    path: 'goto',
    loadComponent: () =>
      import('./common/containers/go-to-container.component').then(
        (m) => m.GoToContainerComponent
      ),
    canActivate: [canActivateAuthGuard],
  },
  {
    path: 'main',
    loadComponent: () =>
      import('./common/containers/main-container.component').then(
        (m) => m.MainContainerComponent
      ),
    canActivate: [canActivateAuthGuard],
  },
  {
    path: 'facility-sign-in/:facilityUid',
    loadComponent: () =>
      import('./locations/containers/facility-sign-in-landing/facility-sign-in-landing.component').then(
        (m) => m.FacilitySignInLandingComponent
      ),
  },
  {
    path: 'facility-sign-in-form/:facilityUid',
    loadComponent: () =>
      import('./locations/containers/facility-sign-in/facility-sign-in.component').then(
        (m) => m.FacilitySignInComponent
      ),
  },
  {
    path: 'facility-sign-out/:facilityUid',
    loadComponent: () =>
      import('./locations/containers/facility-sign-out/facility-sign-out.component').then(
        (m) => m.FacilitySignOutComponent
      ),
  },
  /**
   * The following handles bad routes.  This is where we would put a 404 page not found component if we want to support that.
   * Right now all we do is redirect to /main so we don't allow users to guess valid pages.
   *
   * NOTE: This must stay as the last route so others trigger route events before falling to the redirect.
   */
  { path: '**', redirectTo: '/main' },
];
